import { LOGIN_JWT_SUCCESS } from "../type";
import { saveCartApi } from "../../services/api.services";
import { hasNewCheckout } from "../../helper/utility";

let syncTimeout = null;

const CART_ACTIONS = ["ADD_PRODUCT", "CHANGE_QUANTITY", "DELETE_PRODUCT", "DELETE_ALL", "CHECK_PRODUCT"];

const cartSyncMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  // Retrocompatibilita': tenant senza x_client_token non usa lo stack v2 ->
  // niente sync carrello (eviterebbe chiamate a vuoto al backend v2).
  if (!hasNewCheckout()) return result;

  // On login: sync local cart to server
  if (action.type === LOGIN_JWT_SUCCESS) {
    const state = store.getState();
    const list = state.groceryList?.list;
    if (list && list.length > 0) {
      const items = list.map((item) => ({
        id_prodotto: item.item_id,
        quantity: item.quantity,
        price: parseFloat(item.currentPrice || item.price || 0),
      }));
      saveCartApi({ items }).catch(() => {});
    }
  }

  // On cart changes: debounced sync if authenticated
  if (CART_ACTIONS.includes(action.type)) {
    const state = store.getState();
    if (state.authJWT?.isAuthenticated) {
      if (syncTimeout) clearTimeout(syncTimeout);
      syncTimeout = setTimeout(() => {
        const currentState = store.getState();
        const list = currentState.groceryList?.list;
        if (list) {
          const items = list.map((item) => ({
            id_prodotto: item.item_id,
            quantity: item.quantity,
            price: parseFloat(item.currentPrice || item.price || 0),
          }));
          saveCartApi({ items }).catch(() => {});
        }
      }, 1500);
    }
  }

  return result;
};

export default cartSyncMiddleware;
